"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageManager = void 0;
class LocalStorageManager {
    constructor(handler, saleorState) {
        this.getHandler = () => this.handler;
        this.addItemToCheckout = (params) => {
            var _a;
            const { variantId } = params, otherParams = __rest(params, ["variantId"]);
            const lines = [
                Object.assign(Object.assign({}, otherParams), { variant: {
                        id: variantId,
                    } }),
            ];
            const alteredCheckout = Object.assign(Object.assign({}, (((_a = this.saleorState) === null || _a === void 0 ? void 0 : _a.checkout) && Object.assign({}, this.saleorState.checkout))), { isSamedayEligible: params.isSamedayEligible, lines });
            // Remove any previous completed order
            this.handler.setOrder({});
            this.handler.setCheckout(alteredCheckout);
            return alteredCheckout;
        };
        this.addItemToCart = (variantId, quantity) => {
            var _a;
            const lines = ((_a = this.saleorState.checkout) === null || _a === void 0 ? void 0 : _a.lines) || [];
            let variantInCheckout = lines.find(variant => variant.variant.id === variantId);
            const alteredLines = lines.filter(variant => variant.variant.id !== variantId);
            const newVariantQuantity = variantInCheckout
                ? variantInCheckout.quantity + quantity
                : quantity;
            if (variantInCheckout) {
                variantInCheckout.quantity = newVariantQuantity;
                alteredLines.push(variantInCheckout);
            }
            else {
                variantInCheckout = {
                    quantity,
                    variant: {
                        id: variantId,
                    },
                };
                alteredLines.push(variantInCheckout);
            }
            const alteredCheckout = this.saleorState.checkout
                ? Object.assign(Object.assign({}, this.saleorState.checkout), { lines: alteredLines }) : {
                lines: alteredLines,
            };
            // Remove any previous completed order
            this.handler.setOrder({});
            this.handler.setCheckout(alteredCheckout);
            return alteredCheckout;
        };
        this.removeItemFromCart = (variantId) => {
            var _a;
            const lines = ((_a = this.saleorState.checkout) === null || _a === void 0 ? void 0 : _a.lines) || [];
            const variantInCheckout = lines.find(variant => variant.variant.id === variantId);
            const alteredLines = lines.filter(variant => variant.variant.id !== variantId);
            if (variantInCheckout && this.saleorState.checkout) {
                variantInCheckout.quantity = 0;
                alteredLines.push(variantInCheckout);
            }
            const alteredCheckout = this.saleorState.checkout
                ? Object.assign(Object.assign({}, this.saleorState.checkout), { lines: alteredLines }) : {
                lines: alteredLines,
            };
            this.handler.setCheckout(alteredCheckout);
            return alteredCheckout;
        };
        this.subtractItemFromCart = (variantId) => {
            var _a;
            const lines = ((_a = this.saleorState.checkout) === null || _a === void 0 ? void 0 : _a.lines) || [];
            const variantFromCart = lines.find(variant => variant.variant.id === variantId);
            const alteredLines = lines.filter(variant => variant.variant.id !== variantId);
            const newVariantQuantity = variantFromCart
                ? variantFromCart.quantity - 1
                : 0;
            if (variantFromCart) {
                variantFromCart.quantity = newVariantQuantity;
                alteredLines.push(variantFromCart);
            }
            const alteredCheckout = this.saleorState.checkout
                ? Object.assign(Object.assign({}, this.saleorState.checkout), { lines: alteredLines }) : {
                lines: alteredLines,
            };
            this.handler.setCheckout(alteredCheckout);
            return alteredCheckout;
        };
        this.updateItemInCart = (variantId, quantity) => {
            var _a;
            const lines = ((_a = this.saleorState.checkout) === null || _a === void 0 ? void 0 : _a.lines) || [];
            const variantInCheckout = lines.find(variant => variant.variant.id === variantId);
            const alteredLines = lines.filter(variant => variant.variant.id !== variantId);
            if (variantInCheckout) {
                variantInCheckout.quantity = quantity;
                alteredLines.push(variantInCheckout);
            }
            const alteredCheckout = this.saleorState.checkout
                ? Object.assign(Object.assign({}, this.saleorState.checkout), { lines: alteredLines }) : {
                lines: alteredLines,
            };
            this.handler.setCheckout(alteredCheckout);
            return alteredCheckout;
        };
        this.handler = handler;
        this.saleorState = saleorState;
    }
}
exports.LocalStorageManager = LocalStorageManager;
//# sourceMappingURL=index.js.map